import styled from 'styled-components'

export const DashIconStyleContainer = styled.div`
  margin-top: -3px;
  margin-left: -3px;
`
